import cn from 'bem-cn';

import { List, Skeleton, Stack } from '../../../UI';

import './ChallengeCriterias.scss';

const b = cn('challenge-criterias');

const renderCriteria = () => <Skeleton height="100%" style={{ borderRadius: 24 }} />;
const extractTagKey = (_: unknown, index: number) => `skeleton-criteria-${index}`;

export const ChallengeCriteriasSkeleton = () => {
    return (
        <Stack className={b()}>
            <h2 className={b('title')}>
                <Skeleton width="80%" />
            </h2>
            <List
                direction="row"
                className={b('list')}
                items={[1, 2, 3]}
                renderItem={renderCriteria}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
